// @mui
import { Theme, SxProps } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
//
import CasEmptyContent from '../CasEmptyContent/CasEmptyContent';
// ----------------------------------------------------------------------

type Props = {
  notFound: boolean;
  title?: string;
  sx?: SxProps<Theme>;
};

export default function CasTableNoData({ notFound, title = 'No Data', sx }: Props) {
  return (
    <TableRow>
      {notFound ? (
      <TableCell colSpan={5}>
        <CasEmptyContent
          filled
          title={title}
        />
      </TableCell>
      ) : (
        <TableCell colSpan={5} sx={{ p: 0 }} />
      )}
    </TableRow>
  );
}
